import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";

export type CollectionCardData = {
  id: string;
  name: string;
  theme_color: string | null;
  created_at: number;
};

export function CollectionCard({ collection }: { collection: CollectionCardData }) {
  return (
    <Link to={`/collections/${collection.id}`} className="group block">
      <Card className="overflow-hidden p-0 transition-shadow hover:shadow-md">
        <div
          className="h-32 transition-transform group-hover:scale-[1.02]"
          style={{
            background: collection.theme_color ?? "var(--muted)",
          }}
        />
        <div className="p-4">
          <p className="font-medium tracking-tight">{collection.name}</p>
          <p className="text-xs text-muted-foreground">
            {new Date(collection.created_at).toLocaleDateString(undefined, {
              dateStyle: "medium",
            })}
          </p>
        </div>
      </Card>
    </Link>
  );
}
